import React, { useEffect } from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";
// import { useAuthUserQuery } from "../apollo/auth/queries";
import useAbility from "../shared/hooks/useAbility";
import { Actions, Subjects } from "../shared/contexts/AbilityContext";
import useAuthToken from "../shared/hooks/useAuthToken";
import LoadingPage from "../pages/Home/LoadingPage";
import useAuthStore from "../shared/hooks/useAuthStore";

interface PrivateRouteProps extends RouteProps {
  can?: [Actions, Subjects];
  isCustomer?: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  children,
  can,
  isCustomer,
  ...rest
}) => {
  const { user, isLoading, authError } = useAuthStore(
    ({ user, isLoading, authError }) => ({
      user,
      isLoading,
      authError
    })
  );
  // const { loading, error, user } = useAuthUserQuery();
  // useEffect(() => {
  //   if (error) {
  //     removeToken();
  //   }
  // }, [error]);

  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (authError) {
          return (
            <Redirect
              to={{
                pathname: "/",
                state: { from: location }
              }}
            />
          );
        }

        //If this is not a customer route but the user is a customer and tries to access it we should redirect them to a customer route
        if (user && user.isCustomer && !isCustomer) {
          return (
            <Redirect
              to={{
                pathname: "/myProperty",
                state: { from: location }
              }}
            />
          );
        }
        //If this is a customer route but the user is not a customer and tries to access it we should redirect them to the dashboard
        if (user && !user.isCustomer && isCustomer) {
          return (
            <Redirect
              to={{
                pathname: "/dashboard",
                state: { from: location }
              }}
            />
          );
        }

        if (user) return children;

        return <LoadingPage />;
      }}
    />
  );
};

export default PrivateRoute;
